import { isTypeTimelineItem, TypeTimelineItemSkeleton } from '@platform/contentful';
import { Entry } from 'contentful';
import MarkdownText from './util/MarkdownText';
import cx from 'classix';

const ContentfulTimelineItem = ({
  entry,
  itemNumber,
  isLastItem,
}: {
  entry: Entry<TypeTimelineItemSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
  // Renders on the left if odd, on the right if even
  itemNumber: number;
  isLastItem?: boolean;
}) => {
  if (!entry || !isTypeTimelineItem(entry)) {
    return null;
  }

  const isOdd = itemNumber % 2 === 1;

  return (
    <div
      className={cx(
        'relative sm:w-1/2 text-left',
        // Note that mobile always renders on the left
        'self-end ml-4 pl-12 sm:ml-0 sm:pl-0 sm:self-start sm:mr-4 sm:pr-12',
        // The sm:!mr-0.5 here is a tiny hack to make the borders line up exactly, not that you'd really notice
        // with the icons present.
        isOdd && 'sm:!self-end sm:!ml-4 sm:!mr-0.5 sm:!pl-12 sm:!pr-0',
        !isLastItem &&
          'pb-12 border-l-2 border-r-gray-200 sm:border-l-0 sm:border-r-2 sm:border-r-gray-200',
        !isLastItem && isOdd && 'sm:!pr-12 sm:!border-l-2 sm:!border-r-0 sm:!border-r-gray-200',
      )}
    >
      <h3 className='mb-2 font-header text-xl sm:text-2xl leading-6 sm:leading-7 font-medium text-gray-500'>
        {entry.fields.header}
      </h3>
      <MarkdownText text={entry.fields.description ?? ''} />
      <div
        className={cx(
          `absolute -top-3 fa fal fa-${entry.fields.icon} w-15 h-15 text-4xl bg-white text-gray-200 flex items-center justify-center`,
          '-left-7.5 sm:left-auto sm:-right-7.5',
          isOdd && 'sm:!-left-7.5 sm:!right-auto',
        )}
      />
    </div>
  );
};

export default ContentfulTimelineItem;
